import { Injectable } from '@angular/core';
import { SacraGemSwapper__factory } from '@data/abi';
import { TransactionDataModel } from '@models/transaction-data.model';
import { ErrorService } from '@services/error.service';
import { FeesExtension } from '@services/onchain/FeesExtension';
import { ProviderService } from '@services/provider.service';
import { GET_SACRA_GEM_SWAPPER } from '@shared/constants/addresses/addresses.constant';
import { adjustGasLimit } from '@shared/utils';
import { NGXLogger } from 'ngx-logger';
import { catchError, concatMap, from, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SacraGemSwapperService extends FeesExtension {
  constructor(
    private providerService: ProviderService,
    private errorService: ErrorService,
    private logger: NGXLogger,
  ) {
    super();
  }

  // --- FACTORIES ---

  createSacraGemSwapper(chainId: number) {
    return SacraGemSwapper__factory.connect(GET_SACRA_GEM_SWAPPER(chainId), this.providerService.getProviderForRead());
  }

  // --- CALLS ---

  swap(account: string, chainId: number, amount: bigint) {
    this.logger.trace('swap', account, chainId, amount);
    return from(this.createSacraGemSwapper(chainId).swap.estimateGas(amount, account)).pipe(
      switchMap(gasEstimation => this.updateCurrentFees$(this.providerService, gasEstimation)),
      concatMap(gas => {
        return this.providerService.onChainCall(
          new TransactionDataModel({
            name: 'Swap',
            isNeedUpdateHero: false,
            txPopulated: this.createSacraGemSwapper(chainId).swap.populateTransaction(amount, account),
            gasLimit: adjustGasLimit(gas),
            maxFeePerGas: this.maxFeePerGas,
            maxPriorityFeePerGas: this.maxPriorityFeePerGas,
            gasPrice: this.gasPrice,
            isDelegatedRelayPossible: false,
          }),
        );
      }),
      catchError(this.errorService.onCatchError),
    );
  }
}
